import { useEffect } from 'react';

import { Settings } from 'luxon';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

const useLuxonDefaultLocale = (language: ShortCodeEnums.Language) => {
    useEffect(() => {
        Settings.defaultLocale = language;
    }, [language]);
};

export default useLuxonDefaultLocale;
